
import React from 'react';
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Product } from '@/lib/supabase/products/types';
import SearchBar from './SearchBar';
import ProductList from './ProductList';
import QuantityInput from './QuantityInput';
import CustomProductForm from './CustomProductForm';

interface ProductSelectorContentProps {
  showCustomProduct: boolean;
  searchTerm: string;
  selectedProduct: Product | null;
  quantity: string;
  productName: string;
  productPrice: string;
  loading: boolean;
  error?: string | null;
  filteredProducts: Product[];
  setSearchTerm: (term: string) => void;
  setSelectedProduct: (product: Product) => void;
  setQuantity: (qty: string) => void;
  setShowCustomProduct: (show: boolean) => void;
  setProductName: (name: string) => void;
  setProductPrice: (price: string) => void;
  onAddProduct: () => void;
}

const ProductSelectorContent = ({
  showCustomProduct,
  searchTerm,
  selectedProduct,
  quantity,
  productName,
  productPrice,
  loading,
  error,
  filteredProducts,
  setSearchTerm,
  setSelectedProduct,
  setQuantity,
  setShowCustomProduct,
  setProductName,
  setProductPrice,
  onAddProduct
}: ProductSelectorContentProps) => {
  if (showCustomProduct) {
    return (
      <CustomProductForm
        productName={productName}
        productPrice={productPrice}
        quantity={quantity}
        setProductName={setProductName}
        setProductPrice={setProductPrice}
        setQuantity={setQuantity}
        onAddProduct={onAddProduct}
        onCancel={() => setShowCustomProduct(false)}
      />
    );
  }

  return (
    <div className="space-y-4">
      <SearchBar 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
      />
      
      <ScrollArea className="h-[400px] pr-4 -mr-4">
        <ProductList 
          loading={loading} 
          error={error}
          filteredProducts={filteredProducts} 
          selectedProduct={selectedProduct} 
          setSelectedProduct={setSelectedProduct}
          onShowCustomProduct={() => setShowCustomProduct(true)}
        />
      </ScrollArea>
      
      {selectedProduct && (
        <div className="pt-4 border-t">
          <QuantityInput 
            quantity={quantity} 
            setQuantity={setQuantity} 
          />
          
          <Button 
            className="w-full mt-4" 
            onClick={onAddProduct}
          >
            Ajouter
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductSelectorContent;
